import axios from '../axiosConfig'
import i18n from '../lang/idiomas'

import { tokenConfig } from './auth'
import { createMessage } from './messages'
import {
  DELETE_DOM_ENVIO,
  DELETE_DOM_ENVIO_FAIL,
  DOM_ENVIO_DONE,
  FETCH_DOM_ENVIO,
  FETCH_ESTADO,
  FETCH_PROVINCIA,
  GET_DOM_ENVIO,
  GET_ESTADO,
  GET_PROVINCIA,
  SET_DIRECCION
} from './types'

// GET DOMICILIOS DE ENVIO DEL CLIENTE
export const getDomEnvio = () => (dispatch, getState) => {
  dispatch({
    type: FETCH_DOM_ENVIO,
  })
  axios
    .get('/domicilios/', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_DOM_ENVIO,
        payload: res.data,
      })
    })
    .catch(err => console.log(err))
}

// GET ESTADO
export const getEstado = estado => (dispatch, getState) => {
  dispatch({
    type: FETCH_ESTADO,
  })
  axios
    .get(`/estados/?search=${estado}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_ESTADO,
        payload: res.data[0],
      })
    })
    .catch(err => console.log(err))
}

// GET PROVINCIA
export const getProvincia = (estado, provincia) => (dispatch, getState) => {
  dispatch({
    type: FETCH_PROVINCIA,
  })
  axios
    .get(`/provincias/?estado=${estado}&provincia=${provincia}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_PROVINCIA,
        payload: res.data[0],
      })
    })
    .catch(err => console.log(err))
}

export const setDireccion = direccion => dispatch => {
  dispatch({
    type: SET_DIRECCION,
    payload: direccion,
  })
}

export const deleteDomEnvio = id => (dispatch, getState) => {
  dispatch({
    type: DELETE_DOM_ENVIO,
  })
  axios
    .delete(`/domicilios/${id}/`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_DOM_ENVIO,
        payload: res.data,
      })
      dispatch(createMessage(i18n.t('domicilios.dombosuc'), 'success'))
    })
    .catch(err => {
      dispatch({
        type: DELETE_DOM_ENVIO_FAIL,
      })
      dispatch(createMessage(i18n.t('domicilios.domboerr'), 'error'))
    })
}

export const updateDomEnvio = data => (dispatch, getState) => {
  dispatch({
    type: FETCH_DOM_ENVIO,
  })
  const index = data.id
  axios
    .put(`/domicilios/${index}/`, JSON.stringify(data), tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_DOM_ENVIO,
        payload: res.data,
      })
    })
    .catch(err => console.log(err))
}

export const newDomEnvio = data => (dispatch, getState) => {
  // dispatch({
  //   type: FETCH_DOM_ENVIO,
  // })
  axios
    .post(`/domicilios/`, JSON.stringify(data), tokenConfig(getState))
    .then(res => {
      dispatch(createMessage(i18n.t('domicilios.domencre'), 'success'))
      dispatch({
        type: GET_DOM_ENVIO,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({
        type: DOM_ENVIO_DONE,
      })
      dispatch(createMessage(i18n.t('domicilios.codposer'), 'error'))
    })
}